import styled from "styled-components";

import { BaseCell } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";

import { TruncatedTextWithTooltip } from "app/pages/sales-intelligence/common-components/TruncatedText";

export const StyledBaseCell = styled(BaseCell)`
    display: flex;
`;

export const StyledContactNameText = styled(TruncatedTextWithTooltip)`
    border-radius: 40px;
    padding: 4px 12px;
    background-color: ${colorsPalettes.carbon[50]};
`;
